import { css } from '@emotion/react'
import { memo, ReactNode } from 'react'
import { getThemeSpacing } from '../styles/appTheme'
import { palette } from '../styles/colors'
import BadgeAvatar from './BadgeAvatar'
import Name from './Name'

const rootStyles = css({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: getThemeSpacing(0.5),
    marginBottom: getThemeSpacing(0.5),
})

const rootLargeStyles = css([
    rootStyles,
    {
        paddingTop: getThemeSpacing(),
        paddingBottom: getThemeSpacing(),
    },
])

const rootEmbeddedStyles = css([
    rootStyles,
    {
        marginBottom: 0,
    },
])

const titleStyles = css({
    color: palette.primary,
    marginBottom: getThemeSpacing(),
    fontWeight: 'bold',
})

const titleAvatarStyles = css([
    titleStyles,
    {
        marginBottom: 0,
        fontSize: '.8125rem',
    },
])

const avatarContainerStyles = css({
    paddingTop: getThemeSpacing(1),
})

const nameStyles = css({
    textAlign: 'center',
    paddingTop: getThemeSpacing(1),
    fontSize: '2rem',
})

const embeddedStyles = css({
    display: 'flex',
    flexFlow: 'row nowrap',
    alignItems: 'center',
    '& > h6': {
        padding: 0,
    },
    '& > div': {
        marginTop: 2,
        paddingLeft: getThemeSpacing(1),
    },
})

const nameFontSize = css({
    fontSize: 16,
})

interface NameAvatarProps {
    avatar?: number
    inlineName?: boolean
    showAvatar?: boolean
    addBoxShadow?: boolean
    broadcasting?: boolean
    offline?: boolean
    title?: string
    item?: boolean
    color?: string
    children?: ReactNode
    name?: string
    id?: number
    small?: boolean
    embedded?: boolean
    styleOverrides?: any
}

const NameAvatar = memo((props: NameAvatarProps) => {
    const {
        showAvatar = true,
        addBoxShadow = false,
        broadcasting,
        children,
        offline,
        title,
        color,
        name,
        id,
        small = false,
        embedded = false,
        styleOverrides,
    } = props
    return (
        <div
            css={[
                embedded
                    ? rootEmbeddedStyles
                    : !small
                      ? rootLargeStyles
                      : rootStyles,
                styleOverrides,
            ]}
        >
            {showAvatar && (
                <div css={avatarContainerStyles}>
                    <BadgeAvatar
                        size={!small ? 112 : 50}
                        broadcasting={broadcasting}
                        addBoxShadow={addBoxShadow}
                        offline={offline}
                        alt={name}
                        id={id}
                    />
                </div>
            )}
            <div css={embedded && !showAvatar ? embeddedStyles : nameStyles}>
                <Name
                    color={color}
                    text={name}
                    overrides={small ? nameFontSize : null}
                />
                {!!title && (
                    <div
                        css={
                            showAvatar || embedded
                                ? titleAvatarStyles
                                : titleStyles
                        }
                    >
                        {title}
                    </div>
                )}
            </div>
            {children}
        </div>
    )
})

export default NameAvatar
